import { render } from "./DetailRetourPage.vue?vue&type=template&id=760703ae&ts=true"
import script from "./DetailRetourPage.vue?vue&type=script&lang=ts"
export * from "./DetailRetourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__